// html5-qrcode requires a DOM element even for still-image decode (it renders
// the source image into it). We make a hidden temp div, decode, then clean up.
// Library is lazy-loaded to keep ~200KB out of the initial bundle.
export async function decodeBarcodeFromFile(file: File): Promise<string> {
  const { Html5Qrcode } = await import("html5-qrcode");
  const tempId = `barcode-decode-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  const div = document.createElement("div");
  div.id = tempId;
  div.style.cssText = "position:absolute;left:-9999px;width:1px;height:1px;overflow:hidden;";
  document.body.appendChild(div);

  const scanner = new Html5Qrcode(tempId);
  try {
    return await scanner.scanFile(file, false);
  } finally {
    try {
      await scanner.clear();
    } catch {
      // ignore — scanner may already be cleared
    }
    div.remove();
  }
}
